<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Add Note</p>
            </header>
            <section class="modal-card-body">
                <o-field>
                    <o-input placeholder="What would you like to say?" maxlength="200" type="textarea"></o-input>
                </o-field>
                <div class="field">
                    <o-checkbox>Email Notification</o-checkbox>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button @click.prevent="success" class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    export default {
        props: ['email', 'password'],

        methods: {
            success() {
                this.$parent.$parent.$emit('update:active', false)
                this.$swal.fire({
                    text: 'Note was successfull added',
                    icon: 'success'
                })
            }, 
        }
    }
</script>